<template>
	<div class="message-cls" v-loading="loading">
		<el-popover
			v-model="isPopover"
			placement="bottom-start"
			width="300"
			trigger="click">
			<div class="msg-context">
				<div class="header">
					<span>消息</span>
					<span @click.stop="allUpdReadByUser">全部已读</span>
				</div>
				<div class="context">
					<div @click.stop="handleView(item)" class="cell" v-for="(item, index) in list" :key="index">
						<div class="left" :class="{'unread' : item.read == '0'}">
							<img v-if="['1', '3'].includes(item.type)" :src="`${cdnUrl}/static/images/settingImage.png`">
							<img v-else-if="!['1', '3'].includes(item.type) && item.sendUserImg" :src="`${apiUrl}/filemark/getFile/${item.sendUserImg}`">
							<img v-else :src="`${cdnUrl}/static/images/avat.png`">
						</div>
						<div class="right">
							<div class="top">
								<span>{{['1', '3'].includes(item.type) ? '系统消息' : item.sendUserName}}</span>
								<span>{{item.createTime | formatTimeMessage}}</span>
							</div>
							<div class="bottom">{{item.content}}</div>
						</div>
					</div>
				</div>
				<el-empty v-if="list.length === 0" description="暂无数据"></el-empty>
			</div>
			<div slot="reference" class="msg">
				<svg-icon icon-class="KnowMsg" />
				<span>消息</span>
				<el-badge v-if="StoreMessageCount > 0" :value="StoreMessageCount"></el-badge>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	computed: {
		...mapGetters([
			'userInfo',
			'StoreMessageCount'
		])
	},
	data() {
		return {
			cdnUrl: process.env.VUE_APP_BASE_CDN,
			apiUrl: process.env.VUE_APP_BASE_API,
			count: 0,
			isPopover: false,
			loading: false,
			list: [],
			listQuery: {
				projectId: '',
				pageNum: 1,
				pageSize: 50,
				acceptUserId: ''
			}
		}
	},
	watch: {
		isPopover: {
			handler(val){
				if(val) {
					this.getList();
				} 
			},
			immediate: true,
			deep: true
		},
	},
	async created() {
		await this.getList();
		await this.getCount();
	},
	methods: {
		...mapMutations({
			'SET_MESSAGE_COUNT': 'knowService/SET_MESSAGE_COUNT',
		}),
		getList() {
			this.listQuery.projectId = this.userInfo.brandIdentify;
			this.listQuery.acceptUserId = this.userInfo.userId;
			this.$api.apiPostKnowledgeMessageList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.list = [];
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.loading = false;
			});
		},
		handleView(item) {
			this.$api.apiPostKnowledgeMessageGetEntityById({
				id: item.id
			}).then(response => {
				if(response.errcode != 0) return;
				this.SET_MESSAGE_COUNT(item.read == '1' ? null : 'desc');
				this.isPopover = false;
				switch(item.type) {
					case '1':
					case '2': {
						// this.$router.push({path: '/knowledge/review', query: {activeName: 'second'}});
						break;
					}
					case '3': {
						this.$emit('EditBigScreenInfo', item.qaId);
						break;
					}
					case '4': {
						this.$router.push({path: '/knowledge/review', query: {activeName: 'first'}});
						break;
					}
				}
			});
			
		},
		allUpdReadByUser() {
			this.$api.apiPostKnowledgeMessageUpdReadByUser({
				projectId: this.userInfo.brandIdentify,
				id: this.userInfo.userId
			}).then(response => {
				if(response.errcode != 0) return;
				this.SET_MESSAGE_COUNT();
				this.getList();
			});
		},
		getCount() {
			this.SET_MESSAGE_COUNT();
		}
	}
}
</script>

<style lang="scss" scoped>
.message-cls {
	width: 100%;
	height: 45px;
	border-bottom: solid 1px #dcdfe6;
	box-sizing: border-box;
	line-height: 45px;
	background: #F7F8FA;

	& .msg {
		padding: 0 15px;
		line-height: 45px;
		box-sizing: border-box;
		cursor: pointer;
		width: 110px;

		::v-deep .el-badge {
			margin-top: 5px;
		}

		& > span {
			font-size: 14px;
			font-weight: 400;
			color: #566980;
			vertical-align: top;
			margin-right: 2px;
		}

		& .svg-icon {
			vertical-align: top;
			font-size: 18px;
			color: #566980;
			cursor: pointer;
			margin-top: 13.5px;
			margin-right: 4px;
		}
	}

	
}

.msg-context {
	width: 100%;
	height: 500px;

	& > .header {
		width: 100%;
		height: 80px;
		padding: 20px;
		box-sizing: border-box;

		& > span {
			font-size: 14px;
			font-weight: 500;
			color: #337EFF;
			line-height: 16px;
			vertical-align: top;

			&:nth-of-type(2) {
				float: right;
				cursor: pointer;
			}
		}
	}

	& > .context {
		width: 100%;
		height: calc(100% - 80px);
		overflow-x: hidden;
		overflow-y: auto;

		& > .cell {
			width: 100%;
			margin-bottom: 20px;
			padding: 0 15px 0 26px;
			box-sizing: border-box;
			cursor: pointer;

			& > div {
				display: inline-block;
				vertical-align: top;

				&.left {
					width: 48px;
					position: relative;

					& > img {
						width: 42px;
						height: 42px;
						display: block;
						border-radius: 50%;
						// border: 1px solid #D8D8D8;
					}

					&.unread {
						&::before {
							content: "";
							height: 8px;
							width: 8px;
							background: #FF504D;
							position: absolute;
							top: 17px;
							left: -16px;
							border-radius: 50%;
						}
					}
				}

				&.right {
					width: calc(100% - 48px);

					& > .top {
						width: 100%;
						font-size: 14px;
						font-weight: 400;
						color: #3C4353;
						line-height: 20px;
						vertical-align: top;
						margin-bottom: 2px;

						& > span:nth-of-type(1) {
							display: inline-block;
							width: 50%;
							overflow:hidden; //超出的文本隐藏
							text-overflow:ellipsis; //用省略号显示
							white-space:nowrap; //不换行
						}

						& > span:nth-of-type(2) {
							float: right;
						}
					}
					& > .bottom {
						width: 100%;
						font-size: 14px;
						font-weight: 400;
						color: #6C7E91;
						line-height: 20px;
						vertical-align: top;
						margin-bottom: 2px;
					}
				}
			}
		}
	}

	
}
</style>